export default __webpack_public_path__ + "static/media/projects_image.fa5ff5db.svg";